module.exports = {
  config: () => {
    console.warn('[dotenv-browser] Ignored dotenv.config() in browser');
    return {};
  }
};